import { ChevronRight } from "lucide-react";

const FLOW = [
  {
    eyebrow: "Origine",
    title: "Registre officiel",
    desc: "Une obligation administrative ou légale conduit à la publication initiale d'informations dans un cadre encadré.",
  },
  {
    eyebrow: "Mise à disposition",
    title: "Open data",
    desc: "Les données sont rendues réutilisables sous forme de jeux ouverts, libérant un usage que la finalité initiale n'avait pas anticipé.",
  },
  {
    eyebrow: "Reprise",
    title: "Agrégateur privé",
    desc: "Des plateformes structurent, enrichissent et republient ces informations pour les rendre plus accessibles au grand public.",
  },
  {
    eyebrow: "Visibilité",
    title: "Moteurs de recherche",
    desc: "L'indexation transforme une donnée administrative ponctuelle en une exposition durable sur les premières pages de résultats.",
  },
  {
    eyebrow: "Propagation",
    title: "Rediffusions multiples",
    desc: "Une même information peut alors apparaître simultanément sur plusieurs sites, parfois enrichie ou sortie de son contexte initial.",
  },
];

export const FlowDiagram = () => {
  return (
    <div data-testid="cadre-flow" className="mt-12 lg:mt-16">
      {/* Desktop — horizontal flow */}
      <ol className="hidden lg:flex items-stretch gap-0">
        {FLOW.map((step, i) => (
          <li
            key={step.title}
            className="flex-1 flex items-stretch min-w-0"
            data-testid={`cadre-flow-step-${i}`}
          >
            <div className={`flex-1 min-w-0 border rounded-md p-6 flex flex-col ${i >= 3 ? "bg-[#F6E3E0] border-[#EDCFC9]" : "bg-white border-[#E2DEDA]"}`}>
              <span className={`font-mono text-[10px] tracking-[0.22em] uppercase mb-3 ${i >= 3 ? "text-[#B83A34]" : "text-[#8B8F95]"}`}>
                {step.eyebrow}
              </span>
              <h4 className="font-serif text-lg text-[#181A1D] font-normal leading-snug tracking-tight mb-3 text-balance">
                {step.title}
              </h4>
              <div className="h-[2px] w-6 bg-[#E94B3C] mb-3" />
              <p className="text-[13px] text-[#5A5E64] font-normal leading-relaxed text-pretty">
                {step.desc}
              </p>
            </div>
            {i < FLOW.length - 1 ? (
              <div
                aria-hidden="true"
                className="flex items-center justify-center px-2 text-[#B4B8BD]"
              >
                <ChevronRight size={20} strokeWidth={1.2} />
              </div>
            ) : null}
          </li>
        ))}
      </ol>

      {/* Mobile / tablet — vertical flow */}
      <ol className="lg:hidden flex flex-col gap-3">
        {FLOW.map((step, i) => (
          <li key={`m-${step.title}`} data-testid={`cadre-flow-step-mobile-${i}`} className="flex flex-col items-stretch">
            <div className={`border rounded-md p-6 ${i >= 3 ? "bg-[#F6E3E0] border-[#EDCFC9]" : "bg-white border-[#E2DEDA]"}`}>
              <span className={`font-mono text-[10px] tracking-[0.22em] uppercase ${i >= 3 ? "text-[#B83A34]" : "text-[#8B8F95]"}`}>
                {step.eyebrow}
              </span>
              <h4 className="font-serif text-xl text-[#181A1D] font-normal leading-snug tracking-tight mt-2 mb-3 text-balance">
                {step.title}
              </h4>
              <div className="h-[2px] w-6 bg-[#E94B3C] mb-3" />
              <p className="text-[14px] text-[#5A5E64] font-normal leading-relaxed text-pretty">
                {step.desc}
              </p>
            </div>
            {i < FLOW.length - 1 ? (
              <div
                aria-hidden="true"
                className="flex items-center justify-center py-1 text-[#B4B8BD]"
              >
                <svg width="2" height="22" viewBox="0 0 2 22">
                  <line x1="1" y1="0" x2="1" y2="22" stroke="currentColor" strokeWidth="1" />
                </svg>
              </div>
            ) : null}
          </li>
        ))}
      </ol>
    </div>
  );
};
